import React, { useState } from "react";
import Header from "../../components/Header";
import HoverLink from "./HoverLinks";
import GoBack from "../../components/GoBack";
import { ButtonPrimary, ButtonTertiary } from "../../components/Button";

import SalesRecordsTab from "./SalesRecordsTab";
import InventoryTab from "./InventoryTab";
import OverviewTab from "./OverviewTab";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AddInventoryDrawer from "./AddInventoryDrawer";
import { hasPermission } from "../../utils/permissionChecker";
import { PRIVILEGES } from "../../utils/privileges";

const InventoryDetailPage = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [showAddInventoryDrawer, setShowAddInventoryDrawer] = useState(false);
  const { id: productId } = useParams();
  const [searchParams] = useSearchParams();
  const variantId = searchParams.get("variant");
  const navigate = useNavigate();
  const [stockAdded, setStockAdded] = useState(false);
  const [overviewRefetch, setOverviewRefetch] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const inventorySummary = useSelector(
    (state) => state.inventory.inventorySummary
  );

  const product = inventorySummary.find(
    (item) => String(item.variant_id) === String(variantId)
  );

  if (!product) return <div>Loading...</div>;

  // Updated onStockAdded function to handle different action types
  const handleStockAdded = (actionType) => {
    if (actionType === "manual_stock") {
      // Route to inventory tab for manual stock addition
      setActiveTab("inventory");
      setStockAdded(true);
    } else if (actionType === "stock_request") {
      // For stock requests
      if (activeTab === "overview") {
        // If already on overview tab, trigger a refetch
        setOverviewRefetch((prev) => !prev);
      } else {
        // Route to overview tab for stock requests
        setActiveTab("overview");
      }
    }
  };

  return (
    <>
      <div className="mb-3">
        <GoBack />
      </div>
      {/* Header with tabs */}
      <Header
        text={
          product
            ? `${product.product_name}${
                product
                  ? `/${product?.variant_data?.type}/${product?.variant_data?.value}${product?.variant_data?.unit}`
                  : ""
              }`
            : "Product Inventory"
        }
        tabs={
          <div className="flex gap-4 mt-2">
            <HoverLink
              text="Overview"
              isActive={activeTab === "overview"}
              onClick={() => setActiveTab("overview")}
            />
            <HoverLink
              text="Sales Records"
              isActive={activeTab === "salesRecords"}
              onClick={() => setActiveTab("salesRecords")}
            />
            <HoverLink
              text="Inventory"
              isActive={activeTab === "inventory"}
              onClick={() => setActiveTab("inventory")}
            />
          </div>
        }
        children={
          <div className="flex gap-2">
            <ButtonPrimary onclick={() => setShowAddInventoryDrawer(true)}>
              Add Stock
            </ButtonPrimary>
            {hasPermission(user, PRIVILEGES.EDIT_PRODUCT) && (
              <ButtonTertiary
                onclick={() => navigate(`/edit-product/${productId}`)}
              >
                Edit Product
              </ButtonTertiary>
            )}
          </div>
        }
      />
      {/* Only show content based on active tab */}
      {activeTab === "overview" && (
        <OverviewTab overviewRefetch={overviewRefetch} />
      )}
      {activeTab === "inventory" && (
        <InventoryTab activeTab={activeTab} stockAdded={stockAdded} />
      )}

      {activeTab === "salesRecords" && (
        <SalesRecordsTab activeTab={activeTab} />
      )}

      {/* Add Inventory Drawer */}
      <AddInventoryDrawer
        showDrawer={showAddInventoryDrawer}
        setShowDrawer={setShowAddInventoryDrawer}
        productId={productId}
        variantId={variantId}
        onStockAdded={handleStockAdded}
        activeTab={activeTab}
        setStockAdded={setStockAdded}
        product={product}
      />
    </>
  );
};

export default InventoryDetailPage;
